import axios from 'axios'

export default function registerInterestForm() {
	return {
		email: '',
		firstName: '',
		lastName: '',
		emailPreferred: false,
		phonePreferred: false,
		postPreferred: false,
		selectedDevelopment: '',
		errors: [],
		responseMessage: '',
		isSubmitting: false,
		redirectUrl: '',

		async submitForm(e) {
			e.preventDefault()

			console.log(this.redirectUrl);


			this.errors = []
			this.responseMessage = ''

			if (!this.selectedDevelopment) {
				this.errors.push('Development is required.')
			}

			if (!this.firstName) {
				this.errors.push('First name is required.')
			}

			if (!this.lastName) {
				this.errors.push('Last name is required.')
			}

			if (!this.email || !this.isValidEmail(this.email)) {
				this.errors.push('Please enter a valid email address.')
			}

			if (this.errors.length) {
				return
			}

			this.isSubmitting = true

			try {
				const form = e.target
				const formData = new FormData(form)

				const response = await axios.post(form.action, formData, {
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					}
				})

				if (response.data?.errors?.length) {
					this.errors = response.data.errors
					return
				}

				if (response.data?.payload) {
					this.responseMessage = response.data?.message || 'Debug mode: payload shown below.'
					console.log('Contact Builder payload:', response.data.payload)
					this.responseMessage = `${this.responseMessage}\n${JSON.stringify(response.data.payload, null, 2)}`
					return
				}

				this.responseMessage = response.data?.message || 'Your form submission has been sent!'
				this.clearForm()
				this.redirect()
			} catch (error) {
				const data = error.response?.data || {}
				this.errors = data.errors || []
				this.responseMessage = data.message || 'Something went wrong when submitting your message.'
			} finally {
				this.isSubmitting = false
			}
		},

		clearForm() {
			this.email = ''
			this.firstName = ''
			this.lastName = ''
			this.emailPreferred = false
			this.phonePreferred = false
			this.postPreferred = false
			this.selectedDevelopment = ''
		},

		redirect() {
			window.location.href = this.redirectUrl
		},

		isValidEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			return emailPattern.test(email)
		}
	}
}

